import { XMarkIcon } from "@heroicons/react/24/outline";
import Dialog from ".";

const DialogSuccess = ({ open, onClose, title, icon, status = "success" }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      width="450px"
      className="!bg-[#FFFFFF] !ring-1 !ring-[#D9D9D9]"
    >
      <div>
        <div className="flex items-center justify-end w-full pb-1">
          {/* <h2 className="text-lg font-bold">{t("Top_Up_Capital")}</h2> */}
          <button
            className="bg-transparent hover:bg-transparent text-black"
            onClick={onClose}
          >
            <XMarkIcon className="w-[18px] h-[18px]" />
          </button>
        </div>

        <div className="mt-3 flex flex-col items-center">
          {!!icon ? (
            icon
          ) : status === "success" ? (
            <svg
              viewBox="0 0 88 89"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[100px] h-[100px]"
            >
              <circle
                opacity="0.12"
                cx="44"
                cy="44.375"
                r="44"
                fill="#1DBE3A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44 80.375C63.8823 80.375 80 64.2573 80 44.375C80 24.4928 63.8823 8.375 44 8.375C24.1178 8.375 8 24.4928 8 44.375C8 64.2573 24.1178 80.375 44 80.375ZM60.682 38.557C62.4393 36.7996 62.4393 33.9504 60.682 32.193C58.9246 30.4357 56.0754 30.4357 54.318 32.193L39.5 47.011L33.682 41.193C31.9246 39.4357 29.0754 39.4357 27.318 41.193C25.5607 42.9504 25.5607 45.7996 27.318 47.557L36.318 56.557C38.0754 58.3143 40.9246 58.3143 42.682 56.557L60.682 38.557Z"
                fill="#1DBE3A"
              />
            </svg>
          ) : (
            <svg
              viewBox="0 0 88 89"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[100px] h-[100px]"
            >
              <g clip-path="url(#clip0_1173_5145)">
                <path
                  opacity="0.12"
                  d="M44 88.375C68.3005 88.375 88 68.6755 88 44.375C88 20.0745 68.3005 0.375 44 0.375C19.6995 0.375 0 20.0745 0 44.375C0 68.6755 19.6995 88.375 44 88.375Z"
                  fill="#FF0000"
                />
                <path
                  d="M44 80.375C63.8823 80.375 80 64.2573 80 44.375C80 24.4928 63.8823 8.375 44 8.375C24.1178 8.375 8 24.4928 8 44.375C8 64.2573 24.1178 80.375 44 80.375Z"
                  fill="#FF0000"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M43.9992 48.2432L54.6052 58.8492C55.168 59.412 55.9313 59.7282 56.7272 59.7282C57.5231 59.7282 58.2864 59.412 58.8492 58.8492C59.412 58.2865 59.7282 57.5231 59.7282 56.7272C59.7282 55.9313 59.412 55.168 58.8492 54.6052L48.2392 43.9992L58.8472 33.3932C59.1257 33.1146 59.3467 32.7838 59.4974 32.4197C59.648 32.0557 59.7256 31.6655 59.7255 31.2715C59.7254 30.8775 59.6477 30.4874 59.4968 30.1234C59.346 29.7595 59.1249 29.4288 58.8462 29.1502C58.5675 28.8717 58.2367 28.6508 57.8727 28.5001C57.5087 28.3494 57.1185 28.2719 56.7245 28.272C56.3305 28.2721 55.9404 28.3498 55.5764 28.5006C55.2124 28.6515 54.8817 28.8726 54.6032 29.1512L43.9992 39.7572L33.3932 29.1512C33.1166 28.8646 32.7857 28.6359 32.4197 28.4785C32.0538 28.3211 31.6602 28.2381 31.2618 28.2345C30.8635 28.2309 30.4684 28.3066 30.0997 28.4572C29.7309 28.6079 29.3959 28.8305 29.1141 29.1121C28.8322 29.3936 28.6093 29.7284 28.4583 30.0971C28.3073 30.4657 28.2312 30.8607 28.2345 31.259C28.2377 31.6574 28.3203 32.0511 28.4774 32.4171C28.6344 32.7832 28.8628 33.1144 29.1492 33.3912L39.7592 43.9992L29.1512 54.6072C28.8648 54.8841 28.6364 55.2153 28.4794 55.5813C28.3223 55.9474 28.2397 56.3411 28.2365 56.7395C28.2332 57.1378 28.3093 57.5328 28.4603 57.9014C28.6113 58.27 28.8342 58.6049 29.1161 58.8864C29.3979 59.168 29.7329 59.3906 30.1017 59.5412C30.4704 59.6919 30.8655 59.7676 31.2638 59.764C31.6622 59.7603 32.0558 59.6774 32.4217 59.52C32.7877 59.3626 33.1186 59.1339 33.3952 58.8472L43.9992 48.2432Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1173_5145">
                  <rect width="88" height="89" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}

          <span className="font-semibold text-center block mt-6 text-xl">
            {title}
          </span>
        </div>

        <div className="mt-8">
          <button
            type="submit"
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78]"
            onClick={onClose}
          >
            Okay
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogSuccess;
